<!--
 * @Author: wang wenjie wangwenjie@9377.com
 * @Date: 2024-04-03 18:38:09
 * @LastEditors: wang wenjie wangwenjie@9377.com
 * @LastEditTime: 2026-04-08 11:41:54
 * @FilePath: \special-express-web\editor\runtime\vue3\page\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <magic-ui-page :config="pageConfig"></magic-ui-page>
</template>

<script lang="ts">
import { defineComponent, inject, nextTick, reactive } from 'vue';

import Core from '@tmagic/core';
import type { ChangeEvent } from '@tmagic/data-source';
import type { MNode } from '@tmagic/schema';
import { replaceChildNode } from '@tmagic/utils';

export default defineComponent({
  name: 'App',

  setup() {
    const app = inject<Core | undefined>('app');
    const pageConfig = reactive(app?.page?.data || {});

    app?.dataSourceManager?.on('update-data', (nodes: MNode[], sourceId: string, changeEvent: ChangeEvent) => {
      nodes.forEach((node) => {
        replaceChildNode(reactive(node), [pageConfig as MNode]);
      });

      if (!app) return;

      nextTick(() => {
        app.emit('replaced-node', { nodes, sourceId, ...changeEvent });
      });
    });

    return {
      pageConfig,
    };
  },
});
</script>
